(function(angular){
	'use strict';
	
	var dynamicFieldObject = {
		templateUrl: ['STATIC_BASE_PATH', templateUrlFunction],
		bindings: {
			customErrorMessages: '<',
			form: '=',
			dynamicVal: '@',
			label: '@?'
		},
		controller: [
			'$timeout',
			DynamicFieldFunction
		],
		controllerAs: 'field',
		transclude: true
	};
	
	angular
		.module('formValidationModule')
		.component('dynamicField', dynamicFieldObject);
	
	function templateUrlFunction(STATIC_BASE_PATH){
		return STATIC_BASE_PATH + '/static/html/shared/form-validation/field.html';
	}
	
	function DynamicFieldFunction($timeout){
		var field = this;

		field.removeServerSide = function() {
			if(angular.isDefined(field.input)) {
				field.input.$setValidity('serverside', true);
				field.input.serverSideErrorMsgs = undefined;
			}
		};

		field.$onInit = function() {
			if(field.dynamicVal){
				$timeout(function() {
					field.input = field.form[field.dynamicVal];
				});
			}
		};
	}
})(window.angular);